module.exports = __webpack_public_path__ + "static/mac-powell.090bc32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/mac-powell.jpg
// module id = 1310
// module chunks = 168707334958949